import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { AutoInvestmentRules } from '@/modules/investments/SelfDirected/SelfDirected.types';

import { IS_AUTO_QUERY_KEY } from '../../queries/useAutoInvestment.query';

interface Payload {
  amountToKeep: number;
  investorAccountId?: number;
  autoInvestmentRules?: AutoInvestmentRules[];
  status?: string;
  schedulerId?: string;
}
interface Params {
  isEditMode?: boolean;
  investmentId?: string;
  // status?: string;
}
export default (params?: Params) => {
  const queryClient = useQueryClient();
  const { isLoading, mutateAsync, isError, isSuccess } = useMutation(
    (payload: Payload) =>
      params?.isEditMode
        ? api.put(API_URL.INVESTMENT_SCHEDULERS, {
            id: payload?.schedulerId,
            amount_to_keep: payload.amountToKeep,
            ...(payload.autoInvestmentRules
              ? {
                  auto_investment_rules: payload.autoInvestmentRules.filter((item) => item.percentage),
                }
              : {}),
            status: payload.status,
          })
        : api.post(`${API_URL.INVESTMENT_SCHEDULERS}`, {
            investor_account_id: payload.investorAccountId,
            amount_to_keep: payload.amountToKeep,
            ...(payload.autoInvestmentRules
              ? {
                  auto_investment_rules: payload.autoInvestmentRules.filter((item) => item.percentage),
                }
              : {}),
          }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [IS_AUTO_QUERY_KEY],
        });
      },
    }
  );
  return {
    isLoading,
    mutateAsync,
    isError,
    isSuccess,
  };
};
